import {trigger, state, stagger, animate, style, query, transition, keyframes} from '@angular/animations';
export const rotate180 = trigger('rotate180', [
    state('0', style({ 'margin-top': '12px', 'margin-right': '0px', transform: 'rotate(-180deg)' })),
    state('1', style({ 'margin-top': '-4px', 'margin-right': '15px', transform: 'rotate(0deg)' })),
    transition('1 => 0', animate('300ms')),
    transition('0 => 1', animate('300ms'))
]);

export const rotate90 = trigger('rotate90', [
    state('false', style({ transform: 'rotate(0deg)' })),
    state('true', style({ transform: 'rotate(90deg)' })),
    transition('false <=> true', animate('200ms cubic-bezier(0.22, 1, 0.36, 1)'))
]);

export const fadeInOut = trigger('fadeInOut', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-in', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('200ms ease-out', style({ opacity: 0 }))
    ])
]);

export const expandCollapse = trigger('expandCollapse', [
    transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('240ms cubic-bezier(0.22, 1, 0.36, 1)', style({ height: '*', opacity: 1 }))
    ]),
    transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('200ms cubic-bezier(0.4, 0, 1, 1)', style({ height: 0, opacity: 0 }))
    ])
]);
